import React from 'react'
import {
    Container,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Avatar,
    CircularProgress,
    Typography,
} from '@mui/material'
import WorkIcon from '@mui/icons-material/Work'
import BeachAccessIcon from '@mui/icons-material/BeachAccess'
import { Email } from '@mui/icons-material'
import { Slide, Fade } from 'react-awesome-reveal'
import { useConfig } from '../../hooks/useConfig'

const Contact: React.FC = () => {
    const { config, loading } = useConfig()

    if (loading || !config) {
        return (
            <Container
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '50vh',
                }}
            >
                <CircularProgress />
            </Container>
        )
    }

    return (
        <Container
            sx={{
                py: 8,
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Fade triggerOnce>
                <Slide direction="down" triggerOnce>
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{
                            fontSize: { xs: '2rem', md: '3rem' },
                            fontWeight: 700,
                            mb: 6,
                            color: 'primary.main',
                        }}
                    >
                        {config.contact.title}
                    </Typography>
                </Slide>
            </Fade>

            <Fade delay={200} triggerOnce>
                <List
                    sx={{
                        width: '100%',
                        maxWidth: 360,
                        bgcolor: 'background.paper',
                    }}
                >
                    <ListItem
                        button
                        component="a"
                        href={config.contact.email.href}
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <Email />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={config.contact.email.label}
                            secondary={config.contact.email.value}
                        />
                    </ListItem>
                    <ListItem
                        button
                        component="a"
                        href={config.contact.linkedin.href}
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <WorkIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={config.contact.linkedin.label}
                            secondary={config.contact.linkedin.value}
                        />
                    </ListItem>
                    <ListItem
                        button
                        component="a"
                        href={config.contact.github.href}
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <BeachAccessIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={config.contact.github.label}
                            secondary={config.contact.github.value}
                        />
                    </ListItem>
                </List>
            </Fade>
        </Container>
    )
}

export default Contact
